import { useEffect } from 'react';
import {
  getBreadcrumbs,
  getFaqSchema,
  getProductSchema,
} from '@/utils/structuredData';

const IDs = ['ld-breadcrumb', 'ld-faq', 'ld-product'];

function setLd(id, obj) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

function removeLd(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

/**
 * Wstrzykuje schematy JSON-LD do <head> w zależności od bieżącej ścieżki:
 *  - BreadcrumbList: na wszystkich publicznych podstronach
 *  - FAQPage: na /process
 *  - Product: na stronach produktowych / konfiguratorach saun
 */
export default function useStructuredData(pathname) {
  useEffect(() => {
    // BreadcrumbList
    const bc = getBreadcrumbs(pathname);
    if (bc) setLd('ld-breadcrumb', bc);
    else removeLd('ld-breadcrumb');

    // FAQPage na stronie prosess
    if (pathname === '/process') setLd('ld-faq', getFaqSchema());
    else removeLd('ld-faq');

    // Product schema (asynchroniczne wzbogacenie o zdjęcie/cenę)
    let cancelled = false;
    removeLd('ld-product');
    getProductSchema(pathname)
      .then((schema) => {
        if (cancelled) return;
        if (schema) setLd('ld-product', schema);
      })
      .catch(() => {
        if (!cancelled) removeLd('ld-product');
      });

    return () => {
      cancelled = true;
    };
  }, [pathname]);

  // Czyszczenie przy odmontowaniu aplikacji
  useEffect(() => {
    return () => IDs.forEach((id) => removeLd(id));
  }, []);
}